import { ChangeDetectorRef, } from '@angular/core';
import { FormGroup, NgControl, } from '@angular/forms';
import { AssetScope, } from '@models';
import isEqual from 'lodash-es/isEqual';
export var AssetType;
(function (AssetType) {
    AssetType["Text"] = "Text";
    AssetType["Bool"] = "Bool";
    AssetType["Integer"] = "Integer";
    AssetType["Credential"] = "Credential";
})(AssetType || (AssetType = {}));
export var defaultValueFor = function (type, base, readonly) {
    if (base === void 0) { base = null; }
    switch (type) {
        case AssetType.Credential:
            if (readonly) {
                return base != null ?
                    base :
                    null;
            }
            base = base;
            return base &&
                (base.username ||
                    base.password) ?
                base : {
                username: '',
                password: '',
            };
        case AssetType.Bool:
            return base === false ||
                base === true ?
                base :
                false;
        default:
            return base != null ?
                base :
                null;
    }
};
var UiValueTypeComponent = /** @class */ (function () {
    function UiValueTypeComponent(ngControl, _cd) {
        this.ngControl = ngControl;
        this._cd = _cd;
        this.valuePlaceholder = 'Value';
        this.externalNamePlaceholder = 'External Name';
        this.externalNamePlaceholderName = '';
        this.usernamePlaceholder = 'Username';
        this.passwordPlaceholder = 'Password';
        this.truePlaceholder = 'True';
        this.falsePlaceholder = 'False';
        this.tooltipHide = 'Hide';
        this.tooltipShow = 'Show';
        this.registerChange = function (_) { };
        this.registerTouch = function (_) { };
        // prevent cyclic dependency
        if (!!this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    Object.defineProperty(UiValueTypeComponent.prototype, "ValueType", {
        get: function () {
            return AssetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiValueTypeComponent.prototype, "readonlyCredential", {
        get: function () {
            return this._readonlyCredential;
        },
        set: function (value) {
            this._readonlyCredential = value;
            this._value = defaultValueFor(this._type, this._value, value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiValueTypeComponent.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._value = defaultValueFor(value, this._value, this._readonlyCredential);
            this._type = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiValueTypeComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (!isEqual(value, this._value)) {
                this._value = value;
                this.registerChange(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    UiValueTypeComponent.prototype.asCredential = function (value) {
        return value;
    };
    UiValueTypeComponent.prototype.writeValue = function (value) {
        if (!isEqual(value, this._value)) {
            this._value = value;
            this._cd.markForCheck();
        }
    };
    UiValueTypeComponent.prototype.registerOnChange = function (fn) {
        this.registerChange = fn;
    };
    UiValueTypeComponent.prototype.registerOnTouched = function (fn) {
        this.registerTouch = fn;
    };
    UiValueTypeComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return UiValueTypeComponent;
}());
export { UiValueTypeComponent };
